require('./RAIncomingOutgoingStep.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
// @ components
const RAInput = require('components/RAComponents/commons/RAInput/RAInput');
const { InfoTooltip } = require('components/tooltip/tooltip');
// @ utilities
import { FormattedText, formatText } from 'core/i18n';
// @ constants
const { EURO_SYMBOL, INCOMING_OUTGOING_MAX, INCOMINGS, OUTGOINGS } = require('constants/RAConstants');
const { EVENT_DETAIL_OUTGOINS, EVENT_DETAIL_INCOMINGS } = require('constants/uTagConstants/RAConstants');

class RAIncomingOutgoingStep extends React.Component {
    render() {
        const {
            incomingValue,
            outgoingValue,
            disabled,
            title,
            updateIncomingValue,
            updateOutgoingValue,
            recordEventTooltipClick,
            recordEventInputClick,
        } = this.props;
        const containerRowTextClassName = classnames('ra-incoming-outgoing__container__row__text', {
            'ra-incoming-outgoing__container__row__text--disabled': !!disabled,
        });
        const incomingsRowClass = classnames('ra-incoming-outgoing__container__row__incomings', {
            'ra-incoming-outgoing__container__row__incomings--disabled': !!disabled,
        });
        const outgoingsRowClass = classnames('ra-incoming-outgoing__container__row__outgoings', {
            'ra-incoming-outgoing__container__row__outgoings--disabled': !!disabled,
        });

        return (
            <section className="ra-incoming-outgoing">
                <div className="ra-incoming-outgoing__title">
                    {title}
                    <div
                        className="tooltip-wrapper"
                        onClick={() => recordEventTooltipClick && recordEventTooltipClick('')}
                    >
                        <InfoTooltip text={formatText('incomingsOutgoings-titleToolTipContent')} />
                    </div>
                </div>
                <div className="ra-incoming-outgoing__container">
                    <div className="ra-incoming-outgoing__container__row">
                        <div className={containerRowTextClassName}>
                            <FormattedText value="incomingsOutgoings-incomings" />
                        </div>
                        <div
                            className={incomingsRowClass}
                            onClick={() => recordEventInputClick && recordEventInputClick(EVENT_DETAIL_INCOMINGS)}
                        >
                            <RAInput
                                amount={incomingValue}
                                customClassName="ra-incoming-outgoing__input"
                                disabled={disabled}
                                max={INCOMING_OUTGOING_MAX}
                                maxBackEndFractionLength={2}
                                min={0}
                                name={INCOMINGS}
                                onChange={updateIncomingValue}
                                showBlurZero={true}
                            />
                        </div>
                        <div className="ra-incoming-outgoing__container__row__symbol">
                            {EURO_SYMBOL}
                            <div
                                className="tooltip-wrapper"
                                onClick={() =>
                                    recordEventTooltipClick && recordEventTooltipClick(EVENT_DETAIL_INCOMINGS)
                                }
                            >
                                <InfoTooltip text={formatText('incomingsOutgoings-firstToolTipContent')} />
                            </div>
                        </div>
                    </div>
                    <div className="ra-incoming-outgoing__container__row">
                        <div className={containerRowTextClassName}>
                            <FormattedText value="incomingsOutgoings-outgoings" />
                        </div>
                        <div
                            className={outgoingsRowClass}
                            onClick={() => recordEventInputClick && recordEventInputClick(EVENT_DETAIL_OUTGOINS)}
                        >
                            <RAInput
                                amount={outgoingValue}
                                customClassName="ra-incoming-outgoing__input"
                                disabled={disabled}
                                max={INCOMING_OUTGOING_MAX}
                                maxBackEndFractionLength={2}
                                min={0}
                                name={OUTGOINGS}
                                onChange={updateOutgoingValue}
                                showBlurZero={true}
                            />
                        </div>
                        <div className="ra-incoming-outgoing__container__row__symbol">
                            {EURO_SYMBOL}
                            <div
                                className="tooltip-wrapper"
                                onClick={() =>
                                    recordEventTooltipClick && recordEventTooltipClick(EVENT_DETAIL_OUTGOINS)
                                }
                            >
                                <InfoTooltip text={formatText('incomingsOutgoings-secondToolTipContent')} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

RAIncomingOutgoingStep.propTypes = {
    disabled: PropTypes.bool,
    incomingValue: PropTypes.number.isRequired,
    outgoingValue: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    updateIncomingValue: PropTypes.func.isRequired,
    updateOutgoingValue: PropTypes.func.isRequired,
};

module.exports = RAIncomingOutgoingStep;
